import styled from "styled-components";

export const WalletPubWrapper = styled.div`
  padding: 20px 16px;
`;

export const WalletPubTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  color: var(--Black-400, #444444);
  margin-top: 20px;
`;
